import { deleteOfficeOrigin } from "../../../../../actions/Utilities/OfficeOrigin";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteOfficeOrigin = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteOfficeOrigin(ids), {
    onSuccess: (res) => {
      queryClient.invalidateQueries(["GetOfficeOrigin"]);
      toast.fire(
        "Success",
        "Office Origin has been deactivated successfully",
        "success"
      );
    },
    onError: (error) => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Office Origin",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteOfficeOrigin;
